import React, {
  useState, useEffect, useRef, useCallback,
} from "react";
import ReactDOM from "react-dom";
import axios from "axios";


if (!document.getElementById("nm-gfonts")) {
  const l = document.createElement("link");
  l.id = "nm-gfonts"; l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Caveat:wght@400;600;700&family=Kalam:wght@300;400;700&family=Indie+Flower&family=Patrick+Hand&family=Satisfy&family=Shadows+Into+Light+Two&family=Architects+Daughter&family=Dancing+Script:wght@400;700&family=Pacifico&family=Permanent+Marker&family=Amatic+SC:wght@400;700&family=Comic+Neue:wght@400;700&family=Nunito:wght@400;600;700&family=Poppins:wght@400;600&family=Lato:wght@400;700&family=Roboto:wght@400;700&family=Inter:wght@400;600&display=swap";
  document.head.appendChild(l);
}

if (!document.getElementById("nm-base-styles")) {
  const s = document.createElement("style");
  s.id = "nm-base-styles";
  s.textContent = `
    @font-face {
      font-family: 'Aptos';
      src: local('Aptos'), local('Aptos-Regular');
    }
    .nm-panel * { box-sizing: border-box; }
    .nm-panel { font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif; }
    .nm-scrollbar::-webkit-scrollbar { width: 4px; }
    .nm-scrollbar::-webkit-scrollbar-track { background: transparent; }
    .nm-scrollbar::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 2px; }
    .nm-scrollbar-dark::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); }
    .nm-note-row { transition: background 0.15s; }
    .nm-note-row:hover { background: rgba(51,176,247,0.08); }
    .nm-note-row-dark:hover { background: rgba(51,176,247,0.12); }
    .nm-btn {
      background: none; border: none; cursor: pointer;
      display: inline-flex; align-items: center; justify-content: center;
      border-radius: 6px; transition: background 0.15s, color 0.15s;
      padding: 5px; min-width: 28px; min-height: 28px;
      flex-shrink: 0;
    }
    .nm-btn:hover:not(:disabled) { background: rgba(51,176,247,0.12); }
    .nm-btn:disabled { opacity: 0.4; cursor: default; }
    .nm-btn-dark:hover:not(:disabled) { background: rgba(51,176,247,0.18); }
    .nm-textarea { resize: none; outline: none; border: none; background: transparent; width: 100%; font-family: inherit; }
    .nm-input { outline: none; border: none; background: transparent; font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif; }
    .nm-select {
      outline: none; cursor: pointer;
      font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif;
      appearance: none; -webkit-appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2333B0F7'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 6px center;
      padding-right: 20px !important;
    }
    .nm-tab { cursor: pointer; user-select: none; transition: all 0.2s; }
    .nm-color-swatch { cursor: pointer; border-radius: 5px; transition: transform 0.12s; }
    .nm-color-swatch:hover { transform: scale(1.18); }
    .nm-canvas-toolbar { display: flex; align-items: center; gap: 5px; padding: 6px 10px; flex-wrap: wrap; }
    .nm-draw-tool { cursor: pointer; font-size: 13px; padding: 3px 7px; border-radius: 6px; user-select: none; }
    .nm-size-dot { cursor: pointer; border-radius: 50%; transition: transform 0.12s; }
    .nm-size-dot:hover { transform: scale(1.15); }
    .nm-portal-dropdown {
      position: fixed; z-index: 999999; border-radius: 10px; overflow: hidden;
      pointer-events: all;
    }
    .nm-dropdown-item {
      display: flex; align-items: center; gap: 10px; padding: 8px 14px;
      font-size: 0.78rem; font-family: 'Poppins','Segoe UI',system-ui,sans-serif;
      cursor: pointer; transition: background 0.12s; white-space: nowrap;
    }
    .nm-dropdown-item:hover { background: rgba(51,176,247,0.1); }
    .nm-dropdown-item-dark:hover { background: rgba(51,176,247,0.18); }
    .nm-dropdown-item-disabled { opacity: 0.35; cursor: default; pointer-events: none; }
    .nm-toolbar-row {
      display: flex; align-items: center; gap: 3px;
      padding: 4px 10px; flex-wrap: nowrap; overflow-x: auto;
      scrollbar-width: none;
    }
    .nm-toolbar-row::-webkit-scrollbar { display: none; }
    @keyframes nm-spin { to { transform: rotate(360deg); } }
    @keyframes nm-fadein { from { opacity:0; transform:translateY(-4px); } to { opacity:1; transform:translateY(0); } }
    .nm-portal-dropdown { animation: nm-fadein 0.13s ease; }
  `;
  document.head.appendChild(s);
}

const THEME = {
  dark: {
    pageBg:        "#191F45",
    surface:       "#21295C",
    innerBg:       "#141937",
    deepBg:        "#0D1025",
    accent:        "#33B0F7",
    accentHover:   "#29a8ef",
    border:        "rgba(255,255,255,0.08)",
    borderMid:     "rgba(255,255,255,0.12)",
    t1:            "#E0E0E0",
    t2:            "#858585",
    t3:            "#525252",
    danger:        "#ef5350",
    green:         "#4caf50",
    orange:        "#ff9800",
    canvasBg:      "#141937",
  },
  light: {
    pageBg:        "#F6F6F6",
    surface:       "#FFFFFF",
    innerBg:       "#F0F0F0",
    deepBg:        "#E0E0E0",
    accent:        "#1565C0",
    accentHover:   "#1251a0",
    border:        "rgba(0,0,0,0.08)",
    borderMid:     "rgba(0,0,0,0.12)",
    t1:            "#141414",
    t2:            "#525252",
    t3:            "#858585",
    danger:        "#ef5350",
    green:         "#4caf50",
    orange:        "#ff9800",
    canvasBg:      "#fffdf8",
  },
};

// ─── Constants ────────────────────────────────────────────────────────────────
const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:9000";

const api = {
  headers: () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` }),
  getAll: ()      => axios.get(`${BASE_URL}/api/notes`,        { headers: api.headers() }),
  getOne: (id)    => axios.get(`${BASE_URL}/api/notes/${id}`,  { headers: api.headers() }),
  create: (data)  => axios.post(`${BASE_URL}/api/notes`, data,      { headers: api.headers() }),
  update: (id, d) => axios.put(`${BASE_URL}/api/notes/${id}`, d,    { headers: api.headers() }),
  remove: (id)    => axios.delete(`${BASE_URL}/api/notes/${id}`,    { headers: api.headers() }),
};

const fmt = (s) => {
  if (!s) return "";
  return new Date(s).toLocaleDateString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

const FONTS = [
  { label: "Poppins",             css: "'Poppins',system-ui,sans-serif" },
  { label: "Inter",               css: "'Inter',system-ui,sans-serif" },
  { label: "Nunito",              css: "'Nunito',system-ui,sans-serif" },
  { label: "Roboto",              css: "'Roboto',system-ui,sans-serif" },
  { label: "Lato",                css: "'Lato',system-ui,sans-serif" },
  { label: "Caveat",              css: "'Caveat', cursive" },
  { label: "Kalam",               css: "'Kalam', cursive" },
  { label: "Patrick Hand",        css: "'Patrick Hand', cursive" },
  { label: "Comic Neue",          css: "'Comic Neue', cursive" },
  { label: "Indie Flower",        css: "'Indie Flower', cursive" },
  { label: "Architects Daughter", css: "'Architects Daughter', cursive" },
  { label: "Dancing Script",      css: "'Dancing Script', cursive" },
  { label: "Satisfy",             css: "'Satisfy', cursive" },
  { label: "Pacifico",            css: "'Pacifico', cursive" },
  { label: "Permanent Marker",    css: "'Permanent Marker', cursive" },
  { label: "Amatic SC",           css: "'Amatic SC', cursive" },
  { label: "Shadows Into Light",  css: "'Shadows Into Light Two', cursive" },
  { label: "Monospace",           css: "'Courier New', monospace" },
];

const FONT_SIZES = [12, 14, 16, 18, 20, 24, 28, 32];

const TEXT_COLORS = [
  "#E0E0E0","#33B0F7","#4caf50","#ef5350",
  "#ff9800","#ce93d8","#80cbc4","#90a4ae",
  "#f48fb1","#a1887f","#fff176","#ffffff",
];

const DRAW_COLORS = ["#33B0F7","#ef5350","#4caf50","#ff9800","#ce93d8","#ffffff","#E0E0E0","#ff80ab"];

// ─── SVG Icons ────────────────────────────────────────────────────────────────
const Icon = {
  Back: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
    </svg>
  ),
  Add: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>
  ),
  Save: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>
    </svg>
  ),
  Delete: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
    </svg>
  ),
  Close: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    </svg>
  ),
  Fullscreen: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
    </svg>
  ),
  FullscreenExit: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
    </svg>
  ),
  Download: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
    </svg>
  ),
  ColorText: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"/>
    </svg>
  ),
  Note: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M21 15.5c-.28 0-.5-.22-.5-.5V5H3v14h9.5c.28 0 .5.22.5.5s-.22.5-.5.5H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v10c0 .28-.22.5-.5.5zM17 18l-5 5v-5h5z"/>
    </svg>
  ),
  Pen: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    </svg>
  ),
  Brush: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
      <path d="M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"/>
    </svg>
  ),
  Saved: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="#4caf50">
      <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
  ),
  Error: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="#ef5350">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
    </svg>
  ),
  Spin: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ animation: "nm-spin 0.8s linear infinite" }}>
      <path d="M12 4V2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8z"/>
    </svg>
  ),
  // ── NEW: Sun icon for light mode indicator ──
  Sun: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .38-.39.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06z"/>
    </svg>
  ),
  // ── NEW: Moon icon for dark mode indicator ──
  Moon: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/>
    </svg>
  ),
};

// ─── Portal Dropdown ──────────────────────────────────────────────────────────
const PortalDropdown = ({ anchorRef, open, children, T, align = "left" }) => {
  if (!open) return null;
  const rect = anchorRef.current ? anchorRef.current.getBoundingClientRect() : null;
  if (!rect) return null;

  const style = {
    background: T.innerBg,
    border: `1px solid ${T.borderMid}`,
    boxShadow: "0 8px 32px rgba(0,0,0,0.55), 0 2px 8px rgba(0,0,0,0.35)",
    top: rect.bottom + 6,
  };

  if (align === "right") {
    style.left = Math.max(8, rect.right - 190);
  } else {
    style.left = Math.max(8, Math.min(rect.left, window.innerWidth - 180));
  }

  return ReactDOM.createPortal(
    <div className="nm-portal-dropdown" style={style}>
      {children}
    </div>,
    document.body
  );
};

// ─── Reusable Btn ─────────────────────────────────────────────────────────────
const Btn = React.forwardRef(({ onClick, disabled, title, children, style = {}, className = "", isDark }, ref) => (
  <button
    ref={ref}
    className={`nm-btn ${isDark ? "nm-btn-dark" : ""} ${className}`}
    onClick={onClick}
    disabled={disabled}
    title={title}
    style={style}
  >
    {children}
  </button>
));

// ─── Separator ────────────────────────────────────────────────────────────────
const Sep = ({ T }) => (
  <div style={{
    width: 1, height: 18,
    background: T.borderMid,
    flexShrink: 0, margin: "0 2px",
  }} />
);

// ─── Color Picker ─────────────────────────────────────────────────────────────
const ColorPicker = ({ value, onChange, isDark, T }) => {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (btnRef.current && !btnRef.current.contains(e.target)) {
        const drop = document.getElementById("nm-color-drop");
        if (drop && drop.contains(e.target)) return;
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler, true);
    return () => document.removeEventListener("mousedown", handler, true);
  }, [open]);

  return (
    <div style={{ position: "relative", flexShrink: 0 }}>
      <Btn
        ref={btnRef}
        title="Text color"
        isDark={isDark}
        onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}
        style={{ color: T.t2, position: "relative" }}
      >
        <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Icon.ColorText />
          <div style={{
            position: "absolute", bottom: -3, left: "50%", transform: "translateX(-50%)",
            width: 12, height: 3, borderRadius: 1,
            backgroundColor: value, border: `1px solid ${T.borderMid}`,
          }} />
        </div>
      </Btn>

      <PortalDropdown anchorRef={btnRef} open={open} T={T} align="left">
        <div id="nm-color-drop" style={{ padding: "12px" }}>
          <div style={{
            fontSize: "0.65rem", fontWeight: 700, marginBottom: 8,
            letterSpacing: "0.6px", textTransform: "uppercase",
            color: T.t2,
            fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
          }}>
            Text Color
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 6 }}>
            {TEXT_COLORS.map(c => (
              <div
                key={c}
                className="nm-color-swatch"
                title={c}
                onClick={() => { onChange(c); setOpen(false); }}
                style={{
                  width: 22, height: 22, borderRadius: 5,
                  backgroundColor: c,
                  border: value === c
                    ? `2.5px solid ${T.accent}`
                    : `1.5px solid ${T.borderMid}`,
                  boxShadow: value === c ? `0 0 0 2px ${T.accent}44` : "none",
                }}
              />
            ))}
          </div>
        </div>
      </PortalDropdown>
    </div>
  );
};

// ─── Download Menu ────────────────────────────────────────────────────────────
const DownloadMenu = ({ title, text, drawing, isDark, T }) => {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const h = (e) => {
      if (btnRef.current && !btnRef.current.contains(e.target)) {
        const drop = document.getElementById("nm-dl-drop");
        if (drop && drop.contains(e.target)) return;
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", h, true);
    return () => document.removeEventListener("mousedown", h, true);
  }, [open]);

  const downloadTxt = () => {
    const b = new Blob([`${title}\n${"─".repeat(40)}\n\n${text}`], { type: "text/plain" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(b); a.download = `${title || "note"}.txt`; a.click();
    URL.revokeObjectURL(a.href);
  };

  const downloadPng = () => {
    if (!drawing) return;
    const a = document.createElement("a");
    a.href = drawing; a.download = `${title || "drawing"}.png`; a.click();
  };

  const downloadPdf = async () => {
    if (!window.jspdf) {
      await new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
        s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    try {
      const { jsPDF } = window.jspdf;
      const doc = new jsPDF({ unit: "mm", format: "a4" });
      const pageW = doc.internal.pageSize.getWidth();
      const margin = 20;
      const maxW   = pageW - margin * 2;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(20);
      doc.setTextColor(51, 176, 247);
      doc.text(title || "Untitled Note", margin, 24);
      doc.setDrawColor(51, 176, 247);
      doc.setLineWidth(0.5);
      doc.line(margin, 28, pageW - margin, 28);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.setTextColor(26, 26, 46);
      const lines = doc.splitTextToSize(text || "(no text content)", maxW);
      let y = 38;
      lines.forEach(line => {
        if (y > 272) { doc.addPage(); y = 20; }
        doc.text(line, margin, y);
        y += 7;
      });
      if (drawing) {
        try {
          if (y > 220) { doc.addPage(); y = 20; }
          const imgProps = doc.getImageProperties(drawing);
          const imgW = Math.min(maxW, 150);
          const imgH = (imgProps.height / imgProps.width) * imgW;
          doc.addImage(drawing, "PNG", margin, y + 6, imgW, imgH);
        } catch (_) {}
      }
      doc.save(`${title || "note"}.pdf`);
    } catch (err) {
      console.error("PDF generation failed:", err);
      alert("PDF download failed. Please try Text (.txt) instead.");
    }
  };

  const items = [
    { icon: "📝", label: "Text (.txt)",    fn: () => { downloadTxt(); setOpen(false); }, off: false },
    { icon: "📄", label: "Note (PDF)",     fn: () => { downloadPdf(); setOpen(false); }, off: false },
    { icon: "🖼️", label: "Drawing (.png)", fn: () => { downloadPng(); setOpen(false); }, off: !drawing },
    { icon: "📦", label: "Download both",  fn: () => { downloadTxt(); if (drawing) setTimeout(downloadPng, 300); setOpen(false); }, off: !drawing },
  ];

  return (
    <div style={{ position: "relative", flexShrink: 0 }}>
      <Btn ref={btnRef} title="Download" isDark={isDark} onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }} style={{ color: T.t2 }}>
        <Icon.Download />
      </Btn>
      <PortalDropdown anchorRef={btnRef} open={open} T={T} align="right">
        <div id="nm-dl-drop" style={{ padding: "6px 0", minWidth: 190 }}>
          {items.map(({ icon, label, fn, off }) => (
            <div
              key={label}
              onClick={off ? undefined : fn}
              className={`nm-dropdown-item nm-dropdown-item-dark ${off ? "nm-dropdown-item-disabled" : ""}`}
              style={{ color: off ? T.t3 : T.t1 }}
            >
              <span style={{ fontSize: 15 }}>{icon}</span>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </PortalDropdown>
    </div>
  );
};

// ─── Drawing Canvas ───────────────────────────────────────────────────────────
const DrawingCanvas = ({ initialData, onChange, isDark, T }) => {
  const canvasRef = useRef(null);
  const drawing   = useRef(false);
  const lastPos   = useRef(null);
  const toolRef   = useRef("pen");
  const colorRef  = useRef("#33B0F7");
  const lwRef     = useRef(3);
  const onChRef   = useRef(onChange);

  const [tool,  setTool]  = useState("pen");
  const [color, setColor] = useState("#33B0F7");
  const [lw,    setLw]    = useState(3);

  useEffect(() => { toolRef.current  = tool;     }, [tool]);
  useEffect(() => { colorRef.current = color;    }, [color]);
  useEffect(() => { lwRef.current    = lw;       }, [lw]);
  useEffect(() => { onChRef.current  = onChange; }, [onChange]);

  useEffect(() => {
    const cv = canvasRef.current; if (!cv) return;
    const ctx = cv.getContext("2d");
    ctx.fillStyle = T.canvasBg;
    ctx.fillRect(0, 0, cv.width, cv.height);
    if (initialData) {
      const img = new Image();
      img.onload = () => ctx.drawImage(img, 0, 0);
      img.src = initialData;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPos = (e, cv) => {
    const r = cv.getBoundingClientRect();
    const sx = cv.width / r.width, sy = cv.height / r.height;
    const s = e.touches ? e.touches[0] : e;
    return { x: (s.clientX - r.left) * sx, y: (s.clientY - r.top) * sy };
  };

  const doStroke = (ctx, from, to, t, c, w) => {
    ctx.beginPath(); ctx.moveTo(from.x, from.y); ctx.lineTo(to.x, to.y);
    ctx.strokeStyle = t === "eraser" ? T.canvasBg : c;
    ctx.lineWidth   = t === "eraser" ? w * 5 : w;
    ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.stroke();
  };

  useEffect(() => {
    const cv = canvasRef.current; if (!cv) return;
    const ts = (e) => { e.preventDefault(); drawing.current = true; lastPos.current = getPos(e, cv); };
    const tm = (e) => {
      e.preventDefault(); if (!drawing.current) return;
      const ctx = cv.getContext("2d"), p = getPos(e, cv);
      doStroke(ctx, lastPos.current, p, toolRef.current, colorRef.current, lwRef.current);
      lastPos.current = p;
    };
    const te = () => { drawing.current = false; onChRef.current(cv.toDataURL("image/png")); };
    cv.addEventListener("touchstart", ts, { passive: false });
    cv.addEventListener("touchmove",  tm, { passive: false });
    cv.addEventListener("touchend",   te, { passive: false });
    return () => {
      cv.removeEventListener("touchstart", ts);
      cv.removeEventListener("touchmove",  tm);
      cv.removeEventListener("touchend",   te);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startDraw = (e) => { drawing.current = true; lastPos.current = getPos(e, canvasRef.current); };
  const draw      = (e) => {
    if (!drawing.current) return;
    const cv = canvasRef.current, p = getPos(e, cv);
    doStroke(cv.getContext("2d"), lastPos.current, p, tool, color, lw);
    lastPos.current = p;
  };
  const stopDraw  = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };
  const clearCanvas = () => {
    const cv = canvasRef.current, ctx = cv.getContext("2d");
    ctx.fillStyle = T.canvasBg;
    ctx.fillRect(0, 0, cv.width, cv.height);
    onChange("");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="nm-canvas-toolbar" style={{
        flexShrink: 0,
        borderBottom: `1px solid ${T.border}`,
        background: T.innerBg,
      }}>
        {[{ id: "pen", icon: "✏️", label: "Pen" }, { id: "eraser", icon: "🧹", label: "Eraser" }].map(t => (
          <div
            key={t.id}
            className="nm-draw-tool"
            title={t.label}
            onClick={() => setTool(t.id)}
            style={{
              background: tool === t.id ? `${T.accent}26` : "transparent",
              border: tool === t.id ? `1px solid ${T.accent}` : "1px solid transparent",
              color: T.t1,
            }}
          >
            {t.icon}
          </div>
        ))}

        <Sep T={T} />

        {DRAW_COLORS.map(c => (
          <div
            key={c}
            className="nm-color-swatch"
            title={c}
            onClick={() => { setColor(c); setTool("pen"); }}
            style={{
              width: 14, height: 14, borderRadius: "50%", backgroundColor: c,
              border: color === c && tool === "pen"
                ? `2px solid ${T.accent}`
                : `1.5px solid ${T.borderMid}`,
            }}
          />
        ))}

        <Sep T={T} />

        {[1, 3, 6, 12].map(s => (
          <div
            key={s}
            className="nm-size-dot"
            title={`Size ${s}`}
            onClick={() => setLw(s)}
            style={{
              width: Math.max(s * 2, 8), height: Math.max(s * 2, 8),
              borderRadius: "50%",
              backgroundColor: T.t2,
              border: lw === s ? `2px solid ${T.accent}` : "2px solid transparent",
            }}
          />
        ))}

        <div style={{ flex: 1 }} />

        <Btn title="Clear canvas" isDark={true} onClick={clearCanvas} style={{ color: T.danger }}>
          <Icon.Delete />
        </Btn>
      </div>

      <div style={{ flex: 1, overflow: "hidden" }}>
        <canvas
          ref={canvasRef}
          width={800}
          height={500}
          onMouseDown={startDraw}
          onMouseMove={draw}
          onMouseUp={stopDraw}
          onMouseLeave={stopDraw}
          style={{
            width: "100%", height: "100%",
            cursor: tool === "eraser" ? "cell" : "crosshair",
            display: "block", touchAction: "none",
          }}
        />
      </div>
    </div>
  );
};

// ─── Confirm Dialog ───────────────────────────────────────────────────────────
const ConfirmDialog = ({ open, title, message, onConfirm, onCancel, T }) => {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999999,
      display: "flex", alignItems: "center", justifyContent: "center",
      background: "rgba(0,0,0,0.55)",
    }}>
      <div style={{
        background: T.surface, borderRadius: 14, padding: "28px",
        minWidth: 290, maxWidth: 360,
        boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
        border: `1px solid ${T.borderMid}`,
        fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
      }}>
        <div style={{ fontSize: "1rem", fontWeight: 700, color: T.t1, marginBottom: 10 }}>{title}</div>
        <div
          style={{ fontSize: "0.875rem", color: T.t2, marginBottom: 22 }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button
            onClick={onCancel}
            style={{
              padding: "8px 20px", borderRadius: 8,
              border: `1px solid ${T.borderMid}`,
              background: "transparent", cursor: "pointer",
              fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
              fontSize: "0.875rem", color: T.t2,
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "8px 20px", borderRadius: 8, border: "none",
              background: T.danger, color: "#fff",
              cursor: "pointer",
              fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
              fontSize: "0.875rem", fontWeight: 700,
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

// ─── Note Detail ──────────────────────────────────────────────────────────────
const NoteDetail = ({ noteId, onBack, onDeleted, isDark, T }) => {
  const [note,       setNote]       = useState(null);
  const [activeTab,  setActiveTab]  = useState("text");
  const [title,      setTitle]      = useState("");
  const [text,       setText]       = useState("");
  const [drawing,    setDrawing]    = useState("");
  const [status,     setStatus]     = useState("loading");
  const [dirty,      setDirty]      = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [fontFamily, setFontFamily] = useState("'Poppins',system-ui,sans-serif");
  const [fontSize,   setFontSize]   = useState(16);
  const [fontColor,  setFontColor]  = useState(isDark ? "#E0E0E0" : "#141414");

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setStatus("loading");
      try {
        const { data } = await api.getOne(noteId);
        if (cancelled) return;
        const n = data.note;
        setNote(n);
        setTitle(n.title || "");
        setText(n.textContent || "");
        setDrawing(n.drawingData || "");
        if (n.fontFamily) setFontFamily(n.fontFamily);
        if (n.fontSize)   setFontSize(n.fontSize);
        if (n.fontColor)  setFontColor(n.fontColor);
        setStatus("idle");
      } catch { if (!cancelled) setStatus("error"); }
    };
    load();
    return () => { cancelled = true; };
  }, [noteId]);

  useEffect(() => {
    if (!dirty) return;
    const t = setTimeout(async () => {
      setStatus("saving");
      try {
        await api.update(noteId, { title, textContent: text, drawingData: drawing, fontFamily, fontSize, fontColor });
        setStatus("saved"); setDirty(false);
        setTimeout(() => setStatus("idle"), 2000);
      } catch { setStatus("error"); }
    }, 2000);
    return () => clearTimeout(t);
  }, [title, text, drawing, dirty, noteId, fontFamily, fontSize, fontColor]);

  const md = (setter) => (val) => { setter(val); setDirty(true); setStatus("idle"); };

  const saveNow = async () => {
    setStatus("saving");
    try {
      await api.update(noteId, { title, textContent: text, drawingData: drawing, fontFamily, fontSize, fontColor });
      setStatus("saved"); setDirty(false);
      setTimeout(() => setStatus("idle"), 2000);
    } catch { setStatus("error"); }
  };

  const handleDelete = async () => {
    try {
      await api.remove(noteId);
      setDeleteOpen(false); onDeleted(noteId);
    } catch (err) {
      setDeleteOpen(false);
      if (err?.response?.status === 404) onDeleted(noteId);
      else setStatus("error");
    }
  };

  const lineH = Math.round(fontSize * 1.75);

  const selectStyle = {
    fontSize: "0.74rem",
    color: T.t1,
    background: T.innerBg,
    border: `1px solid ${T.borderMid}`,
    borderRadius: 6,
    padding: "4px 22px 4px 8px",
    height: 28,
    minWidth: 0,
    flexShrink: 1,
    cursor: "pointer",
  };

  if (status === "loading" && !note) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: T.t2 }}>
        <Icon.Spin />
      </div>
    );
  }

  const tabActive   = { color: T.accent, borderBottom: `2.5px solid ${T.accent}`, fontWeight: 700 };
  const tabInactive = { color: T.t2,     borderBottom: "2.5px solid transparent", fontWeight: 400 };

  const lineBackground = `repeating-linear-gradient(to bottom,transparent,transparent ${lineH - 1}px,${T.borderMid} ${lineH - 1}px,${T.borderMid} ${lineH}px),${T.pageBg}`;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", background: T.pageBg }}>

      {/* ── Row 1: Back + Title + Status ── */}
      <div style={{
        padding: "0 10px", paddingRight: 76,
        display: "flex", alignItems: "center", gap: 6,
        borderBottom: `1px solid ${T.border}`,
        background: T.surface,
        flexShrink: 0, minHeight: 46,
        position: "relative", zIndex: 10,
      }}>
        <Btn title="Back" isDark={isDark} onClick={onBack} style={{ color: T.t2 }}>
          <Icon.Back />
        </Btn>

        <input
          className="nm-input"
          value={title}
          onChange={e => md(setTitle)(e.target.value)}
          placeholder="Note title…"
          style={{
            flex: 1, minWidth: 0,
            fontSize: "0.85rem", fontWeight: 700,
            color: T.t1,
            padding: "4px 4px",
          }}
        />

        <div style={{ flexShrink: 0, display: "flex", alignItems: "center", width: 18, justifyContent: "center" }}>
          {(status === "loading" || status === "saving") && <span style={{ color: T.t2 }}><Icon.Spin /></span>}
          {status === "saved"  && <Icon.Saved />}
          {status === "error"  && <Icon.Error />}
        </div>
      </div>

      {/* ── Row 2: Formatting toolbar ── */}
      <div className="nm-toolbar-row" style={{
        borderBottom: `1px solid ${T.border}`,
        background: T.surface,
        flexShrink: 0, minHeight: 38,
        gap: 4,
        position: "relative", zIndex: 10,
      }}>
        <select
          className="nm-select"
          value={fontFamily}
          onChange={e => md(setFontFamily)(e.target.value)}
          style={{ ...selectStyle, width: 138 }}
        >
          {FONTS.map(f => (
            <option key={f.css} value={f.css} style={{ fontFamily: f.css }}>{f.label}</option>
          ))}
        </select>

        <select
          className="nm-select"
          value={fontSize}
          onChange={e => md(setFontSize)(Number(e.target.value))}
          style={{ ...selectStyle, width: 62 }}
        >
          {FONT_SIZES.map(s => (
            <option key={s} value={s}>{s}px</option>
          ))}
        </select>

        <Sep T={T} />
        <ColorPicker value={fontColor} onChange={c => md(setFontColor)(c)} isDark={isDark} T={T} />
        <Sep T={T} />
        <DownloadMenu title={title} text={text} drawing={drawing} isDark={isDark} T={T} />
        <Sep T={T} />

        <Btn
          title="Save now"
          isDark={isDark}
          onClick={saveNow}
          disabled={status === "saving"}
          style={{ color: status === "saved" ? T.green : T.t2 }}
        >
          <Icon.Save />
        </Btn>

        <Btn
          title="Delete note"
          isDark={isDark}
          onClick={() => setDeleteOpen(true)}
          style={{ color: T.danger }}
        >
          <Icon.Delete />
        </Btn>
      </div>

      {/* ── Dates ── */}
      {note && (
        <div style={{
          padding: "3px 14px", display: "flex", gap: 14, flexShrink: 0,
          background: T.innerBg,
          borderBottom: `1px solid ${T.border}`,
        }}>
          <span style={{ fontSize: "0.6rem", color: T.t3 }}>
            Created: {fmt(note.createdAt)}
          </span>
          {note.updatedAt !== note.createdAt && (
            <span style={{ fontSize: "0.6rem", color: T.t3 }}>
              Edited: {fmt(note.updatedAt)}
            </span>
          )}
        </div>
      )}

      {/* ── Tabs ── */}
      <div style={{
        display: "flex", flexShrink: 0,
        borderBottom: `1px solid ${T.border}`,
        background: T.surface,
      }}>
        {[
          { id: "text", label: "Text",    TabIcon: Icon.Pen },
          { id: "draw", label: "Drawing", TabIcon: Icon.Brush },
        ].map(tab => (
          <div
            key={tab.id}
            className="nm-tab"
            onClick={() => setActiveTab(tab.id)}
            style={{
              flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
              gap: 6, padding: "8px 0",
              fontSize: "0.76rem",
              fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
              ...(activeTab === tab.id ? tabActive : tabInactive),
            }}
          >
            <tab.TabIcon /> {tab.label}
          </div>
        ))}
      </div>

      {/* ── Content ── */}
      <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>
        {/* Text tab */}
        <div style={{
          display: activeTab === "text" ? "flex" : "none",
          height: "100%", position: "relative",
          background: lineBackground,
        }}>
          <div style={{
            position: "absolute", left: 40, top: 0, bottom: 0, width: 1,
            background: `${T.accent}33`,
            pointerEvents: "none", zIndex: 1,
          }} />
          <textarea
            className="nm-textarea nm-scrollbar nm-scrollbar-dark"
            value={text}
            onChange={e => md(setText)(e.target.value)}
            placeholder="Write your note here…"
            style={{
              height: "100%",
              padding: `10px 14px 14px 54px`,
              color: fontColor,
              fontSize: `${fontSize}px`,
              fontFamily: fontFamily,
              lineHeight: `${lineH}px`,
              overflowY: "auto",
            }}
          />
        </div>

        {/* Draw tab */}
        <div style={{ display: activeTab === "draw" ? "flex" : "none", height: "100%", flexDirection: "column" }}>
          <DrawingCanvas
            initialData={drawing}
            onChange={d => { setDrawing(d); setDirty(true); }}
            isDark={isDark}
            T={T}
          />
        </div>
      </div>

      {status === "error" && (
        <div style={{
          padding: "5px 14px",
          background: `${T.danger}14`,
          borderTop: `1px solid ${T.danger}30`,
          flexShrink: 0,
        }}>
          <span style={{ fontSize: "0.66rem", color: T.danger }}>Sync failed — retrying on next save</span>
        </div>
      )}

      <ConfirmDialog
        open={deleteOpen}
        title="Delete Note?"
        message={`Permanently delete "<strong>${title}</strong>"? This cannot be undone.`}
        onConfirm={handleDelete}
        onCancel={() => setDeleteOpen(false)}
        T={T}
      />
    </div>
  );
};

// ─── Notes List ───────────────────────────────────────────────────────────────
const NotesList = ({ onOpen, onCreated, isDark, deletedIds, T }) => {
  const [notes,    setNotes]    = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [creating, setCreating] = useState(false);
  const [error,    setError]    = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.getAll();
      setNotes(data.notes || []); setError(false);
    } catch { setError(true); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const prevDeletedLen = useRef(0);
  useEffect(() => {
    if (deletedIds.length > prevDeletedLen.current) {
      load(); prevDeletedLen.current = deletedIds.length;
    }
  }, [deletedIds, load]);

  const handleCreate = async () => {
    if (creating) return;
    setCreating(true);
    try {
      const { data } = await api.create({ title: "Untitled Note", textContent: "", drawingData: "" });
      if (!data?.note?._id) throw new Error("No note ID");
      setNotes(p => [data.note, ...p]);
      onCreated(data.note._id);
    } catch (err) {
      console.error("Create note failed:", err);
      setError(true);
    } finally { setCreating(false); }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", background: T.pageBg }}>
      {/* Header */}
      <div style={{
        padding: "10px 14px",
        paddingRight: 76,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        flexShrink: 0,
        background: T.surface,
        borderBottom: `1px solid ${T.border}`,
        position: "relative", zIndex: 10,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ color: T.accent, display: "flex", alignItems: "center" }}><Icon.Note /></span>
          <span style={{
            fontSize: "0.85rem", fontWeight: 700,
            fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
            color: T.t1,
          }}>
            My Notes
          </span>
          <span style={{
            fontSize: "0.7rem", color: T.t2,
            fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
          }}>
            ({notes.length})
          </span>
        </div>
        <Btn
          title="New note"
          isDark={isDark}
          onClick={handleCreate}
          disabled={creating}
          style={{ color: T.accent, width: 30, height: 30 }}
        >
          {creating ? <Icon.Spin /> : <Icon.Add />}
        </Btn>
      </div>

      {/* List */}
      <div
        className={`nm-scrollbar ${isDark ? "nm-scrollbar-dark" : ""}`}
        style={{ flex: 1, overflowY: "auto", background: T.pageBg }}
      >
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 100, color: T.t2 }}>
            <Icon.Spin />
          </div>
        ) : error ? (
          <div style={{ padding: 20, textAlign: "center" }}>
            <span style={{ fontSize: "0.78rem", color: T.danger, fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif" }}>
              Failed to load notes
            </span>
            <br />
            <button
              onClick={load}
              style={{
                marginTop: 8, fontSize: "0.72rem", cursor: "pointer",
                background: "none", border: "none", color: T.accent,
                fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
              }}
            >
              Retry
            </button>
          </div>
        ) : notes.length === 0 ? (
          <div style={{ padding: 36, textAlign: "center" }}>
            <div style={{ fontSize: 40, opacity: 0.15, marginBottom: 12 }}>📝</div>
            <div style={{ fontSize: "0.82rem", fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif", color: T.t2 }}>
              No notes yet
            </div>
            <div style={{ fontSize: "0.72rem", color: T.t3, marginTop: 5, fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif" }}>
              Click + to create your first note
            </div>
          </div>
        ) : notes.map((note, idx) => (
          <div key={note._id}>
            <div
              className={`nm-note-row ${isDark ? "nm-note-row-dark" : ""}`}
              onClick={() => onOpen(note._id)}
              style={{ padding: "10px 14px", cursor: "pointer" }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                <span style={{
                  fontSize: "0.84rem", fontWeight: 600,
                  fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif",
                  color: T.t1,
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 210,
                }}>
                  {note.title || "Untitled Note"}
                </span>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  {note.drawingData && <span title="Has drawing" style={{ fontSize: 10, opacity: 0.5 }}>🖼️</span>}
                  <span style={{ fontSize: 10, opacity: 0.35 }}>✏️</span>
                </div>
              </div>
              <div style={{ display: "flex", gap: 12 }}>
                <span style={{ fontSize: "0.62rem", color: T.t3, fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif" }}>
                  📅 {fmt(note.createdAt)}
                </span>
                {note.updatedAt !== note.createdAt && (
                  <span style={{ fontSize: "0.62rem", color: T.t3, fontFamily: "'Poppins','Segoe UI',system-ui,sans-serif" }}>
                    ✏️ {fmt(note.updatedAt)}
                  </span>
                )}
              </div>
            </div>
            {idx < notes.length - 1 && (
              <div style={{ height: 1, background: T.border, margin: "0 14px" }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// ─── Floating Panel ───────────────────────────────────────────────────────────
// ── Added onToggleTheme prop so the theme button in window controls can call back up ──
const FloatingPanel = ({ children, T, isDark, open, onClose, anchorEl, isFullscreen, onToggleFullscreen, onToggleTheme }) => {
  const MIN_W = 340, MIN_H = 420, DEF_W = 540, DEF_H = 560;
  const [pos,  setPos]  = useState(null);
  const [size, setSize] = useState({ w: DEF_W, h: DEF_H });
  const posRef  = useRef(pos);
  const sizeRef = useRef(size);
  useEffect(() => { posRef.current  = pos;  }, [pos]);
  useEffect(() => { sizeRef.current = size; }, [size]);

  useEffect(() => {
    if (!open) return;
    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      let x = rect.left + rect.width / 2 - DEF_W / 2;
      let y = rect.bottom + 8;
      x = Math.max(8, Math.min(x, window.innerWidth - DEF_W - 8));
      y = Math.max(rect.bottom + 8, Math.min(y, window.innerHeight - DEF_H - 8));
      setPos({ x, y });
    } else {
      setPos({
        x: Math.max(8, window.innerWidth  / 2 - DEF_W / 2),
        y: Math.max(60, window.innerHeight / 2 - DEF_H / 2),
      });
    }
    setSize({ w: DEF_W, h: DEF_H });
  }, [open, anchorEl]);

  const onDragStart = useCallback((e) => {
    if (isFullscreen) return;
    e.preventDefault();
    const startX = e.clientX - posRef.current.x;
    const startY = e.clientY - posRef.current.y;
    const onMove = (ev) => setPos({ x: ev.clientX - startX, y: Math.max(0, ev.clientY - startY) });
    const onUp   = () => { window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp); };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup",   onUp);
  }, [isFullscreen]);

  const onResizeStart = useCallback((e, edgeName) => {
    if (isFullscreen) return;
    e.preventDefault(); e.stopPropagation();
    const { x: px, y: py } = posRef.current;
    const { w: pw, h: ph } = sizeRef.current;
    const sx = e.clientX, sy = e.clientY;
    const onMove = (ev) => {
      const dx = ev.clientX - sx, dy = ev.clientY - sy;
      let w = pw, h = ph, x = px, y = py;
      if (edgeName.includes("e")) w = Math.max(MIN_W, pw + dx);
      if (edgeName.includes("s")) h = Math.max(MIN_H, ph + dy);
      if (edgeName.includes("w")) { w = Math.max(MIN_W, pw - dx); x = px + (pw - w); }
      if (edgeName.includes("n")) { h = Math.max(MIN_H, ph - dy); y = py + (ph - h); }
      setSize({ w, h }); setPos({ x, y });
    };
    const onUp = () => { window.removeEventListener("mousemove", onMove); window.removeEventListener("mouseup", onUp); };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup",   onUp);
  }, [isFullscreen]);

  if (!open || !pos) return null;

  const navbarBottom = (() => {
    if (!anchorEl) return 64;
    let el = anchorEl.parentElement;
    while (el && el !== document.body) {
      const st = window.getComputedStyle(el);
      if (st.position === "fixed" || st.position === "sticky") return el.getBoundingClientRect().bottom;
      el = el.parentElement;
    }
    return anchorEl.getBoundingClientRect().bottom || 64;
  })();

  const panelStyle = isFullscreen
    ? { position: "fixed", top: navbarBottom, left: 0, right: 0, bottom: 0, width: "100vw", height: `calc(100vh - ${navbarBottom}px)`, borderRadius: 0 }
    : { position: "fixed", left: pos.x, top: pos.y, width: size.w, height: size.h, borderRadius: 14 };

  const rh = (cursor, style) => ({ position: "absolute", zIndex: 4, cursor, background: "transparent", ...style });

  const ctrlBtnBase = {
    width: 24, height: 24, borderRadius: "50%", border: "none", cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
    transition: "opacity 0.15s", flexShrink: 0,
  };

  return ReactDOM.createPortal(
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 1299, background: "rgba(0,0,0,0.45)" }} />

      <div
        className="nm-panel"
        style={{
          ...panelStyle,
          zIndex: 1300,
          background: T.pageBg,
          boxShadow: "0 24px 64px rgba(0,0,0,0.65), 0 2px 12px rgba(0,0,0,0.4)",
          border: `1px solid ${T.borderMid}`,
          display: "flex", flexDirection: "column",
          overflow: "visible",
        }}
      >
        {/* Drag handle */}
        {!isFullscreen && (
          <div
            onMouseDown={onDragStart}
            style={{
              position: "absolute",
              top: 6, left: 90, right: 76,
              height: 22,
              cursor: "move", zIndex: 6, userSelect: "none",
              display: "flex", alignItems: "center", justifyContent: "center",
              borderRadius: 6,
            }}
          >
            <div style={{ display: "flex", gap: 3, opacity: 0.2, pointerEvents: "none" }}>
              {[...Array(8)].map((_, i) => (
                <div key={i} style={{ width: 3, height: 3, borderRadius: "50%", backgroundColor: T.t2 }} />
              ))}
            </div>
          </div>
        )}

        {/* Window controls — added theme toggle button (☀️/🌙) to the left of fullscreen */}
        <div style={{ position: "absolute", top: 8, right: 10, display: "flex", gap: 6, zIndex: 20, alignItems: "center" }}>
          {/* ── CHANGED: theme toggle button — shows Sun when dark (click to go light), Moon when light (click to go dark) ── */}
          <button
            title={isDark ? "Switch to Light theme" : "Switch to Dark theme"}
            onClick={(e) => { e.stopPropagation(); onToggleTheme && onToggleTheme(); }}
            onMouseDown={e => e.stopPropagation()}
            style={{
              ...ctrlBtnBase,
              background: "rgba(128,128,128,0.15)",
              color: isDark ? "rgba(255,220,80,0.9)" : "rgba(80,120,200,0.9)",
            }}
          >
            {isDark ? <Icon.Sun /> : <Icon.Moon />}
          </button>
          <button
            title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
            onClick={(e) => { e.stopPropagation(); onToggleFullscreen(); }}
            onMouseDown={e => e.stopPropagation()}
            style={{ ...ctrlBtnBase, background: "rgba(255,190,0,0.18)", color: "rgba(255,210,80,0.9)" }}
          >
            {isFullscreen ? <Icon.FullscreenExit /> : <Icon.Fullscreen />}
          </button>
          <button
            title="Close"
            onClick={(e) => { e.stopPropagation(); onClose(); }}
            onMouseDown={e => e.stopPropagation()}
            style={{ ...ctrlBtnBase, background: "rgba(239,83,80,0.2)", color: "rgba(255,120,120,0.9)" }}
          >
            <Icon.Close />
          </button>
        </div>

        {/* Resize handles */}
        {!isFullscreen && (
          <>
            <div onMouseDown={e => onResizeStart(e, "n")}  style={rh("n-resize",  { top: 0,    left: 8,   right: 8,  height: 5 })} />
            <div onMouseDown={e => onResizeStart(e, "s")}  style={rh("s-resize",  { bottom: 0, left: 8,   right: 8,  height: 5 })} />
            <div onMouseDown={e => onResizeStart(e, "e")}  style={rh("e-resize",  { right: 0,  top: 8,    bottom: 8, width: 5  })} />
            <div onMouseDown={e => onResizeStart(e, "w")}  style={rh("w-resize",  { left: 0,   top: 8,    bottom: 8, width: 5  })} />
            <div onMouseDown={e => onResizeStart(e, "ne")} style={rh("ne-resize", { top: 0,    right: 0,  width: 12, height: 12 })} />
            <div onMouseDown={e => onResizeStart(e, "nw")} style={rh("nw-resize", { top: 0,    left: 0,   width: 12, height: 12 })} />
            <div onMouseDown={e => onResizeStart(e, "se")} style={rh("se-resize", { bottom: 0, right: 0,  width: 12, height: 12 })} />
            <div onMouseDown={e => onResizeStart(e, "sw")} style={rh("sw-resize", { bottom: 0, left: 0,   width: 12, height: 12 })} />
          </>
        )}

        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column", borderRadius: "inherit" }}>
          {children}
        </div>
      </div>
    </>,
    document.body
  );
};

// ─── Main NotesManager ────────────────────────────────────────────────────────
const NotesManager = ({ anchorEl, onClose, isDark: isDarkProp }) => {
  const [systemDark] = useState(() =>
    window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  // ── Internal theme state — defaults to prop if provided, else system preference ──
  const [isDarkInternal, setIsDarkInternal] = useState(
    isDarkProp !== undefined ? isDarkProp : systemDark
  );

  // ── Sync with Navbar's theme whenever the parent prop changes ──
  // Without this, useState only reads isDarkProp once on mount and ignores later changes.
  useEffect(() => {
    if (isDarkProp !== undefined) setIsDarkInternal(isDarkProp);
  }, [isDarkProp]);

  const isDark = isDarkInternal;
  const T      = isDark ? THEME.dark : THEME.light;
  const isMobile = window.innerWidth <= 600;

  const [view,         setView]         = useState("list");
  const [activeNoteId, setActiveNoteId] = useState(null);
  const [deletedIds,   setDeletedIds]   = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const open = Boolean(anchorEl);

  const openNote      = (id) => { setActiveNoteId(id); setView("detail"); };
  const backToList    = ()   => { setView("list"); setActiveNoteId(null); };
  const handleClose   = ()   => { setIsFullscreen(false); onClose(); };
  const handleDeleted = (id) => { setDeletedIds(p => [...p, id]); backToList(); };

  return (
    <FloatingPanel
      open={open}
      anchorEl={anchorEl}
      isDark={isDark}
      T={T}
      onClose={handleClose}
      isFullscreen={isFullscreen || isMobile}
      onToggleFullscreen={() => setIsFullscreen(f => !f)}
      onToggleTheme={() => setIsDarkInternal(d => !d)}
    >
      {view === "list" ? (
        <NotesList
          onOpen={openNote}
          onCreated={openNote}
          isDark={isDark}
          deletedIds={deletedIds}
          T={T}
        />
      ) : (
        <NoteDetail
          noteId={activeNoteId}
          onBack={backToList}
          onDeleted={handleDeleted}
          isDark={isDark}
          T={T}
        />
      )}
    </FloatingPanel>
  );
};

export default NotesManager;